import './loading-indicator.css';

import { Icon } from '../icon/icon';

function determinMargins(props) {
    if (props.margins === "large") {
        return "margins-large";
    }
    if (props.margins === "medium") {
        return "margins-medium";
    }
    if (props.margins === "small") {
        return "margins-small";
    }
    return "";
}

export function LoadingIndicator(props) {
    const margins = determinMargins(props);

    return (
        <div className={`loading-indicator ${margins}`}>
            <Icon name="loading" class="loading-indicator-icon" />
        </div>
    );
}